import React from "react";
import { LogsResponse } from "../../types/statusTypes";

interface AuditLogDialogBodyProps {
  logs: LogsResponse;
}

export default function AuditLogDialogBody({ logs }: AuditLogDialogBodyProps) {
  const columns = [
    "Timestamp",
    "User",
    "Action Name",
    "Details",
  ];

  return (
    <table className="table table-striped text-break">
      <thead>
        <tr>
          {columns.map((col, index) => (
            <th key={index}>{col}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {logs.map(({ timestamp, user, action, details }, index) => (
          <tr key={index}>
            <td>{timestamp}</td>
            <td>{user}</td>
            <td>{action}</td>
            <td>{JSON.stringify(details)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
